import { useMutation, useQueryClient } from "@tanstack/react-query";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateSellerRoles } from "@/lib/query/core/invalidation";

type DeleteStoreRoleInput = {
  storeSlug: string;
  roleId: string;
};

export function useDeleteStoreRoleMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ roleId }: DeleteStoreRoleInput) =>
      apiJsonClient<void>(endpoints.seller.roleById(roleId), {
        method: "DELETE",
      }),
    onSuccess: async (_data, variables) => {
      await invalidateSellerRoles(queryClient, variables.storeSlug);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
  };
}
